.ae{justify-content:center;}